<div class="w-full h-full">
    <app-tab-header [tabs]="tabs">
        <app-print-button
            matTooltip="Export to Excel"
            matTooltipPosition="left"
            matTooltipClass="custom-orange-tooltip"
            style="--print-btn-padding-right: 0;"
            appDisableWithoutPermission="megapay.skusBillers.disbursementInstitutions.edit"
            (click)="print()"
        >
        </app-print-button>
    </app-tab-header>

    <div class="flex flex-col gap-4 px-5">

        <!-- Title + Add (static for now) -->
        <div class="flex justify-between items-center">
            <p class="uppercase orange-text text-xl font-extrabold">disbursement institutions</p>
            <button
                type="button"
                (click)="openCreateDialog()"
                appDisableWithoutPermission="megapay.skusBillers.disbursementInstitutions.edit"
                matTooltip
                class="flex items-center gap-1 uppercase custom-btn btn-dark-orange font-bold text-xs px-4 py-2"
            >
                <iconify-icon height="20" icon="duo-icons:add-circle"></iconify-icon>
                add institution
            </button>
        </div>

        <!-- Filters -->
        <div [formGroup]="filterForm" class="flex flex-col gap-4">
            <div class="grid grid-cols-3 gap-3">
                <div [appHighlightOnActive]="true" class="card-input flex items-center text-xs py-2">
                    <span class="text-xs font-semibold flex-shrink-0" style="width: 50px;">Code:</span>
                    <input
                        formControlName="code"
                        type="text"
                        placeholder="Code"
                        (keydown.enter)="searchList()"
                        class="placeholder-black focus:outline-none w-full bg-transparent h-30-px rounded-md pl-3 italic"
                    >
                </div>

                <div [appHighlightOnActive]="true" class="card-input flex items-center text-xs py-2">
                    <span class="text-xs font-semibold flex-shrink-0" style="width: 55px;">Name:</span>
                    <input
                        formControlName="name"
                        type="text"
                        placeholder="Name"
                        (keydown.enter)="searchList()"
                        class="placeholder-black focus:outline-none w-full bg-transparent h-30-px rounded-md pl-3 italic"
                    >
                </div>

                <div>
                    <app-custom-dropdown-v2
                        label="Institution Type:"
                        labelWidth="110px"
                        [options]="institutionTypeOptions"
                        [selectedText]="institutionType_text"
                        placeholder="Select an Option"
                        (selectionChange)="setInstitutionType($event.label, $event.value)">
                    </app-custom-dropdown-v2>
                </div>
            </div>

            <div class="flex items-center justify-center">
                <button
                    type="button"
                    (click)="searchList()"
                    class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-12 py-2"
                >
                    search
                </button>
            </div>
        </div>
    </div>

    <!-- Table controls -->
    <app-table-controls
        [currentLimit]="size"
        [searchPlaceholder]="'Search'"
        (limitChangeEvent)="onLimitChangeFromComponent($event)"
        (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
        (keydownEvent)="keyDownFunction($event)"
    ></app-table-controls>

    <!-- Data table -->
    <app-data-table
        [tableSubHeader]="tableSubHeader"
        [isLoading]="isLoading"
        [sort_type]="sort_type"
        (toggleOnSort)="sortList($event.key, $event.type)"
        [stickyLastColumn]="true"
    >
        <tr class="focus:outline-none" *ngFor="let inst of institutions">
            <td class="text-center">{{ inst.code | nullWithDefault }}</td>
            <td class="text-center">{{ inst.name | nullWithDefault }}</td>
            <td class="text-center">{{ inst.institutionType | nullWithDefault }}</td>
            <td class="text-center">{{ inst.serviceFeePercentage | number:'1.2-2' | nullWithDefault }}%</td>
            <td class="text-center">{{ inst.serviceFeeFixed | number:'1.2-2' | nullWithDefault }}</td>
            <td class="text-center">{{ inst.convenienceFee | number:'1.2-2' | nullWithDefault }}</td>
            <td class="text-center">
                <button
                    *ngIf="inst.imageUrl; else noImage"
                    type="button"
                    class="text-blue-600 underline"
                    (click)="openImageViewer(inst)">
                    {{ getFileName(inst.imageUrl) }}
                </button>
                <ng-template #noImage>N/A</ng-template>
            </td>
            <td class="text-center">{{ inst.createDate | date:'yyyy-MM-dd HH:mm' | nullWithDefault }}</td>
            <td class="text-center">{{ inst.createUser | nullWithDefault }}</td>
            <td class="text-center">{{ inst.modifyDate | date:'yyyy-MM-dd HH:mm' | nullWithDefault }}</td>
            <td class="text-center">{{ inst.modifyUser | nullWithDefault }}</td>
            <td class="text-center">{{ inst.deleteDate | date:'yyyy-MM-dd HH:mm' | nullWithDefault }}</td>
            <td class="text-center">{{ inst.deleteUser | nullWithDefault }}</td>
            <td class="text-xs text-center">
                <div class="flex items-center space-x-3">
                    <button
                        type="button"
                        appDisableWithoutPermission="megapay.skusBillers.disbursementInstitutions.edit"
                        matTooltip
                        class="power-btn2 active"
                        *ngIf="!inst.deleteDate"
                        (click)="confirmToggleStatus(inst, 'disable')"
                    >
                        Enabled
                    </button>
                    <button
                        type="button"
                        appDisableWithoutPermission="megapay.skusBillers.disbursementInstitutions.edit"
                        matTooltip
                        class="power-btn2"
                        *ngIf="inst.deleteDate"
                        (click)="confirmToggleStatus(inst, 'enable')"
                    >
                        Disabled
                    </button>
                    <button
                        type="button"
                        appDisableWithoutPermission="megapay.skusBillers.disbursementInstitutions.edit"
                        matTooltip
                        class="action-btn-blue2 custom-btn"
                        (click)="openEditDialog(inst)"
                    >
                        Edit
                    </button>
                </div>
            </td>
        </tr>
        <tr *ngIf="!isLoading && institutions.length === 0">
            <td [attr.colspan]="tableSubHeader?.length || 14" class="text-center py-4 h-150-px text-gray-500 italic">
                <span class="font-semibold text-xs uppercase tracking-wide text-black">No records found</span><br>
                <span class="italic text-xs text-black">Try adjusting your search or filter criteria.</span>
            </td>
        </tr>
    </app-data-table>

    <app-pagination
        [currentPage]="current_page"
        [totalPages]="total_pages"
        [pageSize]="size"
        [totalItems]="total"
        (pageChange)="setPage($event)"
        (previousPage)="prevPage()"
        (nextPage)="nextPage()"
        [showTotalEntries]="true"
    ></app-pagination>
</div>

<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>